<template>
  <div id="app" v-cloak :class="isLeaderboard ? 'color-onyx_bg' : ''" :style="{ height: isLeaderboard ? '100vh' : null }">

    <header role="banner" class="banner navbar navbar-default">
      <div id="nav-container" class="container-fluid no-padding-x" :class="isLearnerType ? 'color-gypsum_brd--bottom' : ''">
        <div id="main-nav" role="navigation" aria-label="Main Menu">
          <div class="brand-wrapper menu-container">
            <a class="brand flex items-center" href="https://www.d2l.com/">
              <img src="https://www.d2l.com/wp-content/themes/d2l-2016/dist/images/D2L-preferred-White.svg" alt="D2L Website" class="brand-logo" width="76" height="50">
            </a>
          </div>
        </div>
      </div>
    </header>


    <main>
      <div class="container no-padding-x position-relative">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
import globalMixin from './mixins/global';

export default {
  name: 'App',
  //props: ['currentRoute'],
  data: function() {
    return {
      currentRoute: window.location.pathname
    }
  },
  mixins: [globalMixin],
  /*data: {
    currentRoute: window.location.pathname
  },*/
  watch:{
    $route (to, from){
      this.currentRoute = window.location.pathname
    }
  },

  mounted() {
    // new stylesheet from theme
    if (this.$route.meta.version !== 1) {
      const style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = "https://d2lcomstg.wpenginepowered.com/wp-content/themes/bigdrop-theme/dist-apps/css/apps.min.css"; // update to use prod
      // console.log(style.href)
      document.head.appendChild(style);
    }
  }
}
</script>

<style>
body {
  font-family: "D2LSans", sans-serif;
}

header {
  position: relative !important;
}

a {
  border-bottom: none !important;
}

.active {
  color: black;
}
header.navbar {
  position: relative;
}

ol {
  list-style-type: none;
  padding-left: 0;
}
ol li {
  width: 100%;
}

.container {
  box-shadow: 0 2px 8px -3px #727272;
}

.container,
#events_quiz,
.question-section {
  height: 683px;
}

/* Background CSS */
.background-gradient-1{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q1-BG.png');
}
.background-gradient-2{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q2-BG.png');
}
.background-gradient-3{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q3-BG.png');
}
.background-gradient-4{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q4-BG.png');
}
.background-gradient-5{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q5-BG.png');
}
.background-gradient-6{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q6-BG.png');
}
.background-gradient-7{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q7-BG.png');
}
.background-gradient-8{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q8-BG.png');
}
.background-gradient-9{
  background: url('assets/Imagineer/ImagineerTypesQuiz_Q9-BG.png');
}

.question-image{
  position:relative;
}

.question-image-large{
  position: absolute;
  height: 100%;
  right: 0;
  bottom: 15%;
}

.background-sizing{
  background-size: cover; 
}

.btn.pill {
  font-size: 18px;
  font-size: 1.8rem;
  line-height: 20px;
  line-height: 2rem;
  padding: 15px 25px;
  border-radius: 100px;
}

.btn.pill:disabled {
  background-color: #828791;
}

.homepage_title {
  margin-left: 20px;
  margin-bottom: 60px;
}

.section-info {
  position: relative;
  width: 100%;
  height: 100px;
}

.section-info h2 {
  text-transform: uppercase; 
  margin-bottom: 5px;
}
.section-info h2:before {
  content: "\203A\a0";
  font-size: 1.2em;
}
.section-info div {
  margin-left: 20px;
}
.section-info a,
.section-info a:hover,
.section-info a:focus,
.section-info a:active {
  text-decoration: none;
}

@media (max-width: 768px) {
  .homepage_title {
    margin-bottom: 40px;
  }

  .section-info {
    height: 75px;
  }

  div.section-info-content {
    margin-left: 0;
  }
}

.quiz-question {
  height: 23%;
}
.quiz-answers  {
  height: 77%;
}
@media (max-width: 768px) {
  .quiz-question,
  .quiz-answers { 
    height: initial;
  }
  .quiz-answers .col-md-5 {
    padding-top: 20px;
  }
}

label {
  font-weight: 400;
  cursor: pointer;
}
.question-section label {
  padding-bottom: 5px;
  padding-top: 0;
  padding-left: 3px;
  margin: 0;
}

.buttons {
  position: absolute;
  right: 20px;
  bottom: 20px;
  z-index: 3;
}

.question-buttons {
  right: initial; 
}

.question-buttons button:first-of-type {
  margin-right: 15px;
}

@media (max-width: 992px) {
  header {
    height: 7vh;
  }

  main {
    height: 93vh;
  }

  .quiz-start-section {
    height: 23vh;
  }

  .buttons {
    position: relative;
    padding-top: 40px;
    text-align: right;
  }

  .question-buttons {
    position: relative;
    bottom: 0;
    text-align: left;
    padding-top: 20px;
  }
  .question-buttons button.btn.pill {
    min-width: 140px;
  }
}

.mktoForm {
  width: 100% !important;
}
.mktoButtonWrap {
  margin-left: 0 !important;
}

.mktoFieldCheckbox label,
.mktoHtmlText {
  color: #FFF;
}

.learner-type.container .mktoFieldCheckbox label {
  color: var(--d2lBlack);
}

.color-onyx_txt .mktoFieldCheckbox label,
.color-onyx_txt .mktoHtmlText,
.color-onyx_txt form.mktoForm .mktoError {
  color: #262626;
}

form.mktoForm .mktoFieldWrap .select-arrow:before {
  content: '\276F';
  font-family: initial;
  transform: rotate(90deg);
}

.learner-type-container .mktoFieldRadio.mktoFieldRadio .control__indicator {
  background: none;
  border-color: var(--color-corundum);
  border-width: 2px;
}

.learner-type-container .mktoFieldRadio.mktoFieldRadio .control__indicator:after {
  height: 80%;
  width: 80%;
  top: 10%;
  left: 10%;
}

.learner-type-container .mktoFieldRadio input:checked ~ .control__indicator:after {
  background: var(--color-green-60);
}

#LblsubscriptionConsent,
.mktoHtmlText,
.mktoFieldCheckbox label {
  color: var(--d2lBlack) !important;
}

.leaderboard {
    position: relative;
    height: 400px;
    width: 100%;
    display: flex;
    border-left: solid thin var(--d2lWhite);
}

.leaderboard-standby {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.graph-bar-wrap {
    display: flex;
    justify-content: space-around;
    width: 100%;
    position: relative;
    flex-direction: column;
}

.event-name {
    position: absolute;
    bottom: calc(100% + 10px);
}

.graph-bar-wrap:first-child {
    border-left: none;
}

.graph-bar-x-label {
    position: absolute;
    white-space: nowrap;
    margin: 0 auto;
    right: 0;
    margin-top: 10px;
    margin-left: 10px;
    top: 100%;
    left: 0;
}

.graph-bar-x-label span {
    display: block;
}

.graph-bar-y-label {
    position: absolute;
    right: calc( 100% - 30px );
}

.graph-bar {
    position: relative;
    height: 100%;
    transition: all .5s ease-in-out;
}

.graph-bar > .learner-type-label {
    display: block;
    background: var(--d2lWhite);
    height: 80%;
    max-height: 40px;
    min-height: 20px;
    margin: 0 auto;
    transition: all .5s ease-in-out;
}

.graph-bar > .learner-type-count {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    bottom: 100%;
    opacity: .5;
}

.graph-legend-title {
    text-transform: capitalize;
    display: inline-block;
}

.graph-legend-color {
    position: relative;
    top: 3px;
    margin-right: 10px;
    display: inline-block;
    height: 20px;
    width: 20px;
}

.qrcode-wrap {
    justify-content: space-between;
    flex-direction: column;
}

.qrcode-wrap img {
  margin: 0 auto;
  width: 100%;
  max-width: 150px;
  height: 100%;
}

.leaderboard-info {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
}

.current-leader {
  max-width: 200px;
  margin: 0 auto;
}

.learner-attribute-wrap {
  max-height: 20px;
}

.learner-attribute-icon {
  transform: translateY(calc(-50% + 20px));
}

@media (max-width: 992px) {
  .container,
  #events_quiz,
  .question-section {
    height: initial;
    max-height: none;
  }
  .question-image-large{
    position: relative;
    height: auto;
    bottom: none;
  }
}

@media (max-width: 768px) {
  .learner-attribute-wrap {
    max-height: initial;
  }
  .learner-attribute-icon {
    transform: translateY(0);
  }
}

@media (min-width: 768px) {
  .learner-attribute-icon {
    margin-left: 0;
    padding-right: 10px;
  }
}
</style>
